import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// import JS files
import MuiModal from "../shares/MuiModal";
import MuiButton from "../shares/MuiButton";

// import Others files
import successIcon from "../../imgs/success.svg";

const SuccessModal = (props) => {
  const navigate = useNavigate();
  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-2/5"
      >
        <div className="flex flex-col items-center justify-center p-4">
          <img src={successIcon} />
          <p className="font-bold text-mygray-700 mt-8">
            کاربر گرامی پرونده شما با موفقیت ثبت شد.
          </p>
          <div className="bg-mygray-200 rounded-lg w-1/2 py-4 px-8 flex justify-between items-center mt-4">
            <span>کد رهگیری:</span>
            <span style={{ fontFamily: "iransansenglish" }}>{props.code}</span>
          </div>
          <div className="mt-8">
            <MuiButton
              onClick={() => {
                props.setOpenModal(false);
                navigate("/")
              }}
              type="submit"
              variant="contained"
              color="success"
              text="تایید"
            />
          </div>
        </div>
      </MuiModal>
    </>
  );
};

export default SuccessModal;
